export default "__VITE_ASSET__2e74c5cd__"